import React from 'react';
import { Carousel } from '@cimpress/react-components';

/* eslint-disable jsx-a11y/alt-text */
const CarouselDemo = () => (
  <div>
    <div className="row">
      <div className="col-md-6">
        <h5>Small carousel with thumbnails</h5>
        <Carousel size="s" showZoomOverlay={true}>
          <img src="//via.placeholder.com/600x600/4286f4/ffffff" />
          <img src="//via.placeholder.com/400x600/ffc83d/ffffff" />
          <img src="//via.placeholder.com/600x500/d62896/ffffff" />
          <img src="//via.placeholder.com/600x300/28d696/ffffff" />
          <img src="//via.placeholder.com/300x600/96d628/ffffff" />
          <img src="//via.placeholder.com/400x600/ffc83d/ffffff" />
          <img src="//via.placeholder.com/600x500/d62896/ffffff" />
          <img src="//via.placeholder.com/600x300/28d696/ffffff" />
        </Carousel>
      </div>
      <div className="col-md-6">
        <h5>Medium carousel in landscape mode</h5>
        <Carousel size="m" landscape>
          <img src="//via.placeholder.com/600x600/4286f4/ffffff" />
          <img src="//via.placeholder.com/400x600/ffc83d/ffffff" />
          <img src="//via.placeholder.com/600x500/d62896/ffffff" />
          <img src="//via.placeholder.com/600x300/28d696/ffffff" />
          <img src="//via.placeholder.com/300x600/96d628/ffffff" />
        </Carousel>
      </div>
    </div>
    <div className="row">
      <div className="col-md-4">
        <h5>Minimal carousel at 100px</h5>
        <Carousel minimal pxSize={100} showZoomOverlay={true}>
          <img src="//via.placeholder.com/600x600/4286f4/ffffff" />
          <img src="//via.placeholder.com/400x600/ffc83d/ffffff" />
          <img src="//via.placeholder.com/600x500/d62896/ffffff" />
          <img src="//via.placeholder.com/600x300/28d696/ffffff" />
          <img src="//via.placeholder.com/300x600/96d628/ffffff" />
        </Carousel>
      </div>
      <div className="col-md-4">
        <h5>Extra small carousel with no slides</h5>
        <Carousel size="xs">{/* No children */}</Carousel>
      </div>
      <div className="col-md-4">
        <h5>Extra small carousel in a loading state</h5>
        <Carousel loading size="xs">
          {/* Loading state */}
        </Carousel>
      </div>
    </div>
  </div>
);

export default CarouselDemo;
